import request from '@/config/axios'

export interface AgentProfileVO {
  id?: number
  agentNo?: string
  name?: string
  agentType?: number
  contactName?: string
  contactMobile?: string
  loginAccount?: string
  loginPasswordSet?: boolean
  level?: number
  parentId?: number
  parentName?: string
  regionCode?: string
  regionName?: string
  regionExclusive?: boolean
  status?: number
  kycLicenseUrl?: string
  kycIdCardUrl?: string
  kycIdCardBackUrl?: string
  contractSigned?: boolean
  bankName?: string
  bankAccountNo?: string
  bankAccountName?: string
  rejectReason?: string
  applyTime?: string
  auditTime?: string
  remark?: string
  createTime?: string
}

export interface AgentProfileSimpleVO {
  id: number
  agentNo?: string
  name: string
  regionCode?: string
  regionName?: string
}

export const getAgentProfilePage = (params: any) =>
  request.get<{ list: AgentProfileVO[]; total: number }>({ url: '/agent/profile/page', params })

export const getAgentProfile = (id: number) =>
  request.get<AgentProfileVO>({ url: '/agent/profile/get', params: { id } })

export const updateAgentProfile = (data: AgentProfileVO) =>
  request.put({ url: '/agent/profile/update', data })

export const updateAgentProfileStatus = (data: { id: number; status: number }) =>
  request.put({ url: '/agent/profile/update-status', data })

export const updateAgentProfileLogin = (data: {
  id: number
  loginAccount: string
  password: string
}) => request.put({ url: '/agent/profile/update-login', data })

export const getAgentParentOptions = () =>
  request.get<AgentProfileSimpleVO[]>({ url: '/agent/profile/parent-options' })
